// extracted by mini-css-extract-plugin
export var healthyMetabolismBtn = "HealthyMetabolism-module--healthyMetabolismBtn--WzbUE";
export var healthyMetabolismContent = "HealthyMetabolism-module--healthyMetabolismContent--c-yqQ";
export var healthyMetabolismImage = "HealthyMetabolism-module--healthyMetabolismImage--Nw-Rg";
export var healthyMetabolismText = "HealthyMetabolism-module--healthyMetabolismText--iVndQ";
export var healthyMetabolismWrapper = "HealthyMetabolism-module--healthyMetabolismWrapper--jz2lM";